

import axiosClient from "api/axios_client.js";

const apiSwiftboard = {
    getPresignedUrl: (payload) => axiosClient.post('/file-uploader/generate-presigned-url', payload), 
};

export default apiSwiftboard;



